import { Col, Row } from 'antd';
import styled from 'styled-components';
import {
  actions,
} from 'Slice/TopCompanyEntitySlice';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectLoading, selectExecutives, selectedCompanies } from 'Selector/TopEntitiesSelector';
import { Company } from 'Types/CompaniesTypes';
import { Executive } from 'Types/PersonTypes';
import { maxMobile, maxWidth, minWidthApp } from 'Utils/utilsStyle';
import { Waypoint } from 'react-waypoint';
import { selectDisclessPersonality } from 'Selector/GlobalSearchContentSelector';
import TopCompany from './TopCompanySection';
import TopPeople from './TopPeople';

const StyleWrapper = styled.div`
  margin: 21px 0 0 0;
  @media (min-width: ${minWidthApp}) and (max-width: ${maxWidth}) {
    margin-bottom: 21px;
  }
  .company-row-grid {
    .company-image-parent {
      .progress-wrapper {
        padding: 0px 10px !important;
      }
    }
  }
  .top-person-here {
    @media all and (max-width: ${maxMobile}) {
      margin-top: 20px;
    }
  }
`;

const TopPeopleAndTopCompanies = function TopPeopleAndTopCompanies() {
  const dispatch = useDispatch();
  const loading: boolean = useSelector(selectLoading);
  const executives: Executive[] | undefined = useSelector(selectExecutives);
  const companies: Company[] | undefined = useSelector(selectedCompanies);
  const disclessPersonality = useSelector(selectDisclessPersonality);
  useEffect(() => {
    if (!companies?.length || !executives?.length) {
      dispatch(actions.getTopEntities({}));
    }
    return () => {
      dispatch(actions.resetValues());
    };
  }, []);

  return (
    <Waypoint>
      <StyleWrapper id="tabs-target">
        <Row gutter={16}>
          {companies && (
            <Col span={15} xs={24} sm={24} md={15}>
              <TopCompany companies={companies} loading={loading} />
            </Col>
          )}
          {executives && !disclessPersonality && (
            <Col span={9} xs={24} sm={24} md={9} className="top-person-here">
              <TopPeople executives={executives} loading={loading} />
            </Col>
          )}
        </Row>
      </StyleWrapper>
    </Waypoint>
  );
};

export default TopPeopleAndTopCompanies;
